// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__ABoA-","container":"styles_container__LYgYO","title":"styles_title__2Ubep","wrapper":"styles_wrapper__2mstN","answer":"styles_answer__3GfIP"};